import React from 'react';
import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SliderUiObject from './SliderUiObject';
import ToggleButtonGroupUiObject from './ToggleButtonGroupUiObject';
import LocationWithOptionsUiObject from './LocationWithOptionsUiObject';
import SwitchUiObject from './SwitchUiObject';
import ToggleButtonGroupUiObjectDynamicPrice from './ToggleButtonGroupUiObjectDynamicPrice';
import TableUiObject from './TableUiObject';
import { MultipleTicketsUiObject } from './MultipleTicketsUiObject';

import { OrderPageTypography } from '../themedComponents/OrderPageTypography';

export const UIObjectTypes = {
  SLIDER: 'slider',
  TOGGLE_BUTTON_GROUP: 'toggleButtonGroup',
  TOGGLE_BUTTON_GROUP_DYNAMIC_PRICE: 'toggleButtonGroupDynamicPrice',
  LOCATION_WITH_OPTIONS: 'locationWithOptions',
  SWITCH: 'switch',
  TABLE_DYNAMIC_PRICE: 'tableDynamicPrice',
  MULTIPLE_TICKETS: 'multipleTickets',
};

const UiObjectsList = (props) => {
  const {
    orderState,
    setOrderState,
    setOrderDetailValue,
    setCustomOrderDetailValue,
    setOrderCustomDetails,
    setMultipleTicketsDetails,
    type,
    errors,
    isLoadingDates,
    isEditOrder,
  } = props;
  const { t } = useTranslation();
  // Separate switch objects from other objects
  const switchObjects = orderState.orderPage.objects.filter((object) => object.type === UIObjectTypes.SWITCH);
  const otherObjects = orderState.orderPage.objects.filter((object) => object.type !== UIObjectTypes.SWITCH);
  const renderUiObject = (object) => {
    if (object.type === UIObjectTypes.SLIDER && !orderState.specificOrderPage?.onlyCouples) {
      return (
        <SliderUiObject
          type={type}
          uiObject={object}
          orderState={orderState}
          setOrderDetailValue={setOrderDetailValue}
          isLoadingDates={isLoadingDates}
        />
      );
    }
    if (object.type === UIObjectTypes.MULTIPLE_TICKETS && !orderState.specificOrderPage?.onlyCouples) {
      return (
        <MultipleTicketsUiObject
          uiObject={object}
          orderState={orderState}
          setMultipleTicketsDetails={setMultipleTicketsDetails}
          isLoadingDates={isLoadingDates}
        />
      );
    }
    if (object.type === UIObjectTypes.TOGGLE_BUTTON_GROUP) {
      return (
        <ToggleButtonGroupUiObject
          key={object.id}
          uiObject={object}
          orderState={orderState}
          setOrderDetailValue={setOrderDetailValue}
          setCustomOrderDetailValue={setCustomOrderDetailValue}
          setOrderCustomDetails={setOrderCustomDetails}
        />
      );
    }
    if (object.type === UIObjectTypes.TOGGLE_BUTTON_GROUP_DYNAMIC_PRICE) {
      return (
        <ToggleButtonGroupUiObjectDynamicPrice
          key={object.id}
          uiObject={object}
          orderState={orderState}
          setOrderDetailValue={setOrderDetailValue}
        />
      );
    }
    if (object.type === UIObjectTypes.LOCATION_WITH_OPTIONS) {
      return (
        <LocationWithOptionsUiObject
          key={object.id}
          uiObject={object}
          orderState={orderState}
          setOrderDetailValue={setOrderDetailValue}
          setCustomOrderDetailValue={setCustomOrderDetailValue}
          setOrderCustomDetails={setOrderCustomDetails}
          errors={errors}
        />
      );
    }
    if (object.type === UIObjectTypes.SWITCH) {
      return (
        <SwitchUiObject
          key={object.id}
          uiObject={object}
          orderState={orderState}
          setOrderDetailValue={setOrderDetailValue}
          setCustomOrderDetailValue={setCustomOrderDetailValue}
          errors={errors}
        />
      );
    }
    if (object.type === UIObjectTypes.TABLE_DYNAMIC_PRICE) {
      return (
        <TableUiObject
          key={object.id}
          uiObject={object}
          orderState={orderState}
          setOrderState={setOrderState}
          setOrderDetailValue={setOrderDetailValue}
          errors={errors}
          isEditOrder={isEditOrder}
        />
      );
    }
    return null;
  };

  return (
    <Grid container direction="column" spacing={2}>
      {otherObjects.map((object) => (
        <Grid item key={object.id}>
          <Box id={object.id}>{renderUiObject(object)}</Box>
        </Grid>
      ))}

      {switchObjects.length > 0 && (
        <>
          <Grid item>
            <OrderPageTypography variant="h3" bold sx={{ mt: 2, mb: 2 }}>
              {t('order_page.ui_objects.switches_title')}
            </OrderPageTypography>
          </Grid>
          {switchObjects.map((object) => (
            <Grid item key={object.id} mt={-2}>
              <Box id={object.id}>{renderUiObject(object)}</Box>
            </Grid>
          ))}
        </>
      )}
    </Grid>
  );
};

export default UiObjectsList;
